import { render, staticRenderFns } from "./TableFull.vue?vue&type=template&id=a817463c&scoped=true&"
import script from "./TableFull.vue?vue&type=script&lang=js&"
export * from "./TableFull.vue?vue&type=script&lang=js&"
import style0 from "./TableFull.vue?vue&type=style&index=0&id=a817463c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a817463c",
  null
  
)

export default component.exports